export { LanguageProvider, useLang } from "./LanguageContext";
export type { Lang } from "./LanguageContext";
export { en } from "./en";
export { pl } from "./pl";
export type { Content } from "./en";

import { useLang } from "./LanguageContext";
import { en } from "./en";
import { pl } from "./pl";

export function useTranslation() {
  const { lang } = useLang();
  return lang === "pl" ? pl : en;
}
